module.exports = __webpack_public_path__ + "static/media/sell_report_deal_2.1b5b9c00.png";